import { Injectable, Inject } from "@angular/core";
import {
  Http,
  Response,
  Headers,
  RequestOptions,
  URLSearchParams,
} from "@angular/http";
import { Observable } from "rxjs";
import { environment } from "@environment/environment";
import { Users } from "../admin/Model/admin";
import { GetEnvVarService } from "./get-env-var.service";

@Injectable()
export class AuthService {
  private authUrl: string;
  private access_token: string;
  private baseUrl: string;

  constructor(@Inject(Http) private http: Http, private getEnvVarService: GetEnvVarService) {
    this.baseUrl = this.getEnvVarService.getUserservicebaseurl();
  }

   getToken(authorization_code:string){
//     //this.http.post(this.url+'Oauth/Token',);
      debugger;
          return this.http.get(this.baseUrl + `/api/token/` + authorization_code)
          .map(response => response.json())
           .catch(handleError);
   
 }
  
//  getToken(authorization_code:string){

//        debugger;
//          return this.http.get(this.baseUrl + `/api/userdetail`)
//            .map(response => response.json())
//             .catch(handleError);
     
//    }

  // getUserDetails(token:string){

  getUserDetails(token:string) {
    debugger;
    let headers = new Headers();
    headers.set("Content-Type", "application/x-www-form-urlencoded");
    headers.set('token', token);
    let options = new RequestOptions({ headers: headers });
    return this.http
      .get(environment.stage.idmurl + "userdetail", options)
      .map((response) => response.json());
  }
}
function handleError(error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || ``;
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/service/auth.service.ts